import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;

export const HorizontalSidebarData = [
  {
    title: "Main",
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: "Dashboard",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        subMenus: [
          {
            menuValue: "Admin Dashboard",
            route: routes.adminDashboard,
            base: "index",
          },
          {
            menuValue: "Employee Dashboard",
            route: routes.employeeDashboard,
            base: "employee",
          },
        ],
      },
      {
        menuValue: "Super Admin",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "user-star",
        base: "super-admin",
        subMenus: [
          {
            menuValue: "Dashboard",
            route: routes.superAdminDashboard,
            base: "super-admin-dashboard",
          },
          {
            menuValue: "Companies",
            route: routes.superAdminCompanies,
            base: "companies",
          },
          {
            menuValue: "Subscriptions",
            route: routes.superAdminSubscriptions,
            base: "subscriptions",
          },
          {
            menuValue: "Packages",
            route: routes.superAdminPackages,
            base: "packages",
            base2: "packages-grid",
          },
          {
            menuValue: "Domain",
            route: routes.superAdminDomain,
            base: "domain",
          },
          {
            menuValue: "Purchase Transaction",
            route: routes.superAdminPurchaseTransaction,
            base: "purchase-transaction",
          },
        ],
      },
      {
        menuValue: "Application",
        hasSubRouteTwo: true,
        showSubRoute: false,
        icon: "layout-grid-add",
        base: "application",
        subMenus: [
          {
            menuValue: "Chat",
            route: routes.chat,
            base: "chats",
            customSubmenuTwo: false,
          },
          {
            menuValue: "Calls",
            customSubmenuTwo: true,
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.calendar,
            base: "calls",
            subMenusTwo: [
              {
                menuValue: "Voice Call",
                route: routes.voiceCall,
                hasSubRoute: false,
                showSubRoute: false,
                base: "voice-call",
              },
              {
                menuValue: "Video Call",
                route: routes.videoCall,
                hasSubRoute: false,
                showSubRoute: false,
                base: "video-call",
              },
              {
                menuValue: "Outgoing Call",
                route: routes.outgoingCall,
                hasSubRoute: false,
                showSubRoute: false,
                base: "outgoing-call",
              },
              {
                menuValue: "Incoming Call",
                route: routes.incomingCall,
                hasSubRoute: false,
                showSubRoute: false,
                base: "incoming-call",
              },
              {
                menuValue: "Call History",
                route: routes.callHistory,
                hasSubRoute: false,
                showSubRoute: false,
                base: "call-history",
              },
            ],
          },
          {
            menuValue: "Calendar",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.calendar,
            customSubmenuTwo: false,
            base: "calendar",
          },

          {
            menuValue: "Email",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.email,
            customSubmenuTwo: false,
            base: "email",
          },
          {
            menuValue: "To Do",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.todo,
            customSubmenuTwo: false,
            base: "todo",
          },
          {
            menuValue: "Notes",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.notes,
            customSubmenuTwo: false,
            base: "notes",
          },
          {
            menuValue: "Social Feed",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.socialFeed,
            customSubmenuTwo: false,
            base: "social-feed",
          },
          {
            menuValue: "File Manager",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.fileManager,
            customSubmenuTwo: false,
            base: "file-manager",
          },
          {
            menuValue: "Kanban",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.kanbanView,
            customSubmenuTwo: false,
            base: "kanban",
          },
          {
            menuValue: "Invoices",
            hasSubRoute: true,
            showSubRoute: false,
            route: routes.invoice,
            customSubmenuTwo: false,
            base: "invoices",
          },
        ],
      },
      {
        menuValue: "Layouts",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "layout-board-split",
        base: "layout-horizontal",
        base2: "layout-vertical-transparent",
        base3: "layout-horizontal-box",
        base4: "layout-horizontal-overlay",
        base5: "layout-horizontal-single",
        base6: "layout-modern",
        base7: "layout-detached",
        subMenus: [
          {
            menuValue: "Horizontal",
            route: routes.Horizontal,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-horizontal",
          },
          {
            menuValue: "Detached",
            route: routes.Detached,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-detached",
          },
          {
            menuValue: "Modern",
            route: routes.Modern,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-modern",
          },
          {
            menuValue: "Two Column",
            route: routes.TwoColumn,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-two-column",
          },
          {
            menuValue: "Hovered",
            route: routes.Hovered,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-hovered",
          },
          {
            menuValue: "Boxed",
            route: routes.Boxed,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-boxed",
          },
          {
            menuValue: "Horizontal Single",
            route: routes.HorizontalSingle,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-horizontal-single",
          },
          {
            menuValue: "Horizontal Overlay",
            route: routes.HorizontalOverlay,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-horizontal-overlay",
          },
          {
            menuValue: "Horizontal Box",
            route: routes.HorizontalBox,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-horizontal-box",
          },
          {
            menuValue: "Menu Aside",
            route: routes.MenuAside,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-horizontal-sidemenu",
          },
          {
            menuValue: "Transparent",
            route: routes.Transparent,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-vertical-transparent",
          },
          {
            menuValue: "Without Header",
            route: routes.WithoutHeader,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-without-header",
          },
          {
            menuValue: "RTL",
            route: routes.RTL,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-rtl",
          },
          {
            menuValue: "Dark",
            route: routes.Dark,
            hasSubRoute: false,
            showSubRoute: false,
            base: "layout-dark",
          },
        ],
      },
      {
        menuValue: "Projects",
        hasSubRouteTwo: true,
        showSubRoute: false,
        icon: "user-star",
        base: "client",
        base2: "project",
        base3: "crm",
        base4: "employee",
        base5: "ticket",
        subMenus: [
          {
            menuValue: "Clients",
            route: routes.clientgrid,
            base: "client",
            customSubmenuTwo: false,
          },
          {
            menuValue: "Projects",
            base: "project",
            customSubmenuTwo: true,
            subMenusTwo: [
              {
                menuValue: "Projects",
                route: routes.project,
                base: "project-grid",
                base2: "project-list",
                base3: "project-details",
              },
              { menuValue: "Tasks", route: routes.tasks, base: "tasks" },
              {
                menuValue: "Task Board",
                route: routes.taskboard,
                base: "task-board",
              },
            ],
          },
          {
            menuValue: "Crm",
            base: "crm",
            customSubmenuTwo: true,
            subMenusTwo: [
              {
                menuValue: "Contacts",
                route: routes.contactGrid,
                base: "contact",
              },
              {
                menuValue: "Companies",
                route: routes.companiesGrid,
                base: "company",
              },
              {
                menuValue: "Deals",
                route: routes.dealsGrid,
                base: "deals",
              },
              {
                menuValue: "Leads",
                route: routes.leadsGrid,
                base: "leads",
              },
              {
                menuValue: " Pipeline",
                route: routes.pipeline,
                base: "pipeline",
              },
              {
                menuValue: "Analytics",
                route: routes.analytics,
                base: "analytics",
              },
              {
                menuValue: "Activities",
                route: routes.activities,
                base: "activities",
              },
            ],
          },
          {
            menuValue: "Employee",
            base: "employee",
            customSubmenuTwo: true,
            subMenusTwo: [
              {
                menuValue: "Employees List",
                route: routes.employeeList,
                base: "employees",
                base2: "employee-list",
              },
              {
                menuValue: "Employees Grid",
                route: routes.employeeGrid,
                base: "employees",
                base2: "employee-grid",
              },
              {
                menuValue: "Employees Details",
                route: routes.employeedetails,
                base: "employees",
                base2: "employee-details",
              },
              {
                menuValue: "Departments",
                route: routes.departments,
                base: "departments",
              },
              {
                menuValue: "Designations",
                route: routes.designations,
                base: "designations",
              },
              {
                menuValue: "Policies",
                route: routes.policy,
                base: "employees",
                base2: "policy",
              },
            ],
          },
        ],
      },
    ],
  },
];